import React from 'react'
import { string } from 'prop-types'
import { MediaIframeEmbed } from '../MediaIframeEmbed'

export const YoutubeLive = ({ channel, ...rest }) => {
  if (!channel) return null

  return (
    <MediaIframeEmbed
      src={`https://www.youtube.com/embed/live_stream?channel=${channel}`}
      {...rest}
    />
  )
}

YoutubeLive.propTypes = {
  channel: string,
}
